module.exports = __webpack_public_path__ + "img/404error-light.297c151b.svg";